module.exports = __webpack_public_path__ + "static/media/squarespacevideo.a19b2abe.png";